<template>
  <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6592 8.5H11.3184L14 13H9.28715V16H6.63911V13H2L4.61453 8.5H3.30726L7.96648 1L12.6592 8.5Z"
      fill="#F9F9F9"
    />
  </svg>
</template>
